import styled from 'styled-components';
import Assets from '../../assets/Assets';

const Map = styled.div`
	background-image: url(${Assets.images.map});
	background-size: cover;
	bottom: -4px;
	left: -4px;
	overflow: hidden;
	position: absolute;
	right: -4px;
	top: -4px;
`;

export default Map;
